"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
var _reactRouterDom = require("react-router-dom");
var _DownloadLinkBox = require("../../DownloadLinkBox/DownloadLinkBox");
var _SectionTitle = _interopRequireDefault(require("../SectionTitle/SectionTitle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-hottopics {\n  text-align: left;\n  width: 100%; }\n  .sia-hottopics .tags {\n    display: flex;\n    gap: 4px; }\n  .sia-hottopics .tag {\n    background-color: #fff;\n    color: #000000;\n    border-radius: 12px;\n    padding: 4px 8px 0px 8px;\n    border: 1px solid #000000;\n    width: fit-content;\n    height: 24px; }\n  .sia-hottopics .row {\n    display: flex;\n    align-items: flex-end;\n    gap: 24px; }\n  .sia-hottopics a {\n    text-decoration: none; }\n\n@media (max-width: 66rem) {\n  .sia-hottopics .row {\n    flex-direction: column;\n    align-items: flex-start; } }\n\n@media (max-width: 42rem) {\n  .sia-hottopics {\n    padding-inline: 16px; } }\n";
  const fileName = "HotTopics_HotTopics";
  const element = document.querySelector("style[data-sass-component='HotTopics_HotTopics']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Wrapper = _ref => {
  let {
    link,
    lang,
    children
  } = _ref;
  return link.url === link.original_url ? /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    href: link.url
  }, children) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: (0, _DownloadLinkBox.getInternalUrl)({
      link: {
        link: link,
        section_element: link.section_element
      },
      lang,
      isCMS: true
    }),
    style: {
      maxWidth: '100%'
    }
  }, children);
};
const Topic = _ref2 => {
  let {
    isFirst,
    title,
    themen_tag,
    description,
    link,
    lang
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `topic sia-border-01-bottom  sia-padding-02-left ${!isFirst ? 'sia-margin-02-top' : ''}`
  }, themen_tag && themen_tag.name && /*#__PURE__*/_react.default.createElement("p", {
    className: "tag sia-margin-02-bottom sia-text-06"
  }, themen_tag.name), link && /*#__PURE__*/_react.default.createElement(Wrapper, {
    link: link,
    lang: lang
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row sia-margin-05-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-12",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), description && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-10 sia-margin-02-top",
    dangerouslySetInnerHTML: {
      __html: description
    }
  })), link && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_.default, null)))));
};
const HotTopics = _ref3 => {
  let {
    items,
    lang,
    translate,
    title_background_color
  } = _ref3;
  if (items.length === 0) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-hottopics sia-margin-06-bottom"
  }, /*#__PURE__*/_react.default.createElement(_SectionTitle.default, {
    bgColor: title_background_color
  }, translate('cms.homepage.hottopics')), items.map((topic, index) => {
    return /*#__PURE__*/_react.default.createElement(Topic, _extends({
      key: index,
      isFirst: index === 0,
      lang: lang
    }, topic));
  }));
};
var _default = exports.default = HotTopics;